export default __webpack_public_path__ + "static/media/pasek_progress_poziom.81f0b432.png";